import type { TurnError } from "../contract"

const TITLES: Record<TurnError["code"], string> = {
  tool_unavailable: "Couldn't reach a source NIRA needs",
  model_error: "NIRA could not finish this answer",
  timeout: "This took longer than NIRA allows",
  limit: "NIRA reached its limit for one answer",
  internal: "Something went wrong",
}

/** Calm error in place, with Retry when the server says it is worth trying again. */
export function ErrorCard({ error, onRetry }: { error: TurnError; onRetry?: () => void }) {
  return (
    <article className="ecard" role="alert">
      <p className="ov">NIRA · ERROR</p>
      <h3>{TITLES[error.code] ?? TITLES.internal}</h3>
      <p className="tk">
        {error.message}
        {error.partial ? " The parts above were checked. Nothing below this point is verified." : ""}
      </p>
      {error.retryable && onRetry ? (
        <div className="cacts">
          <button type="button" className="pbtn" onClick={onRetry}>Retry</button>
        </div>
      ) : null}
    </article>
  )
}
